import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaEye } from "react-icons/fa";
import DataTable from "../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";
import { unitwiseviewColumns } from "./UnitWiseOccData";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../../../../../Redux/slice/features/paginationSilce";
import { REACT_APP_API_URL } from "../../../../../env";

const UnitwiseHotelReport = () => {
  const { hotelId } = useParams();
  const [hotelName, setHotelName] = useState("");
  const [dataT, setDataT] = useState([]);

  const currentPage = useSelector((state) => state.pagination.currentPage);
  const itemsPerPage = useSelector((state) => state.pagination.itemsPerPage);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setCurrentPage(1));
  }, [dispatch, hotelId]);

  useEffect(() => {
    const fetchHotel = async () => {
      try {
        const res = await axios.get(
          `${REACT_APP_API_URL}api/dashboard/admin/hotel-name/${hotelId}`
        );
        setHotelName(res.data.PropertyName || "Unknown Hotel");
      } catch (err) {
        console.error("Hotel fetch error:", err);
        setHotelName("Unknown Hotel");
      }
    };

    const fetchBookings = async () => {
      try {
        const res = await axios.get(
          `${REACT_APP_API_URL}api/dashboard/admin/unitwise-occupancyproperty/${hotelId}`
        );
        const formatted = (res.data.data || []).map((item, index) => {
          const rawDate = new Date(item.CheckinDatee);
          return {
            Sl: index + 1,
            Date: !isNaN(rawDate)
              ? rawDate.toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                })
              : "Invalid Date",
            NoofBooking: item.NoofBooking,
            TotalNoofRoom: item.TotalNoOfRoom,
            BookingID: item.BookingID,
            BookingRefNo: (
              <button
                type="button"
                className="text-blue-600 underline"
                onClick={() => navigate(`/booking-view/${item.BookingID}`)}
              >
                {item.BookingRefNo || "View"}
              </button>
            ),
            actions: (
              <button
                type="button"
                className="btn text-blue-600"
                onClick={() =>
                  navigate(
                    `/hotel-booking-details/${hotelId}/${rawDate.toISOString()}`
                  )
                }
              >
                <FaEye />
              </button>
            ),
          };
        });

        setDataT(formatted);
      } catch (err) {
        console.error("Booking fetch error:", err);
        setDataT([]);
      }
    };

    fetchHotel();
    fetchBookings();
  }, [hotelId, navigate]);

  const totalPages = useMemo(
    () => Math.ceil(dataT.length / itemsPerPage),
    [dataT.length, itemsPerPage]
  );
  const indexOfLastItem = useMemo(
    () => currentPage * itemsPerPage,
    [currentPage, itemsPerPage]
  );
  const indexOfFirstItem = useMemo(
    () => indexOfLastItem - itemsPerPage,
    [indexOfLastItem, itemsPerPage]
  );

  const currentItems = useMemo(() => {
    return dataT.slice(indexOfFirstItem, indexOfLastItem);
  }, [dataT, indexOfFirstItem, indexOfLastItem]);

  const handleNextPage = useCallback(() => {
    if (currentPage < totalPages) {
      dispatch(setCurrentPage(currentPage + 1));
    }
  }, [currentPage, totalPages, dispatch]);

  const handlePreviousPage = useCallback(() => {
    if (currentPage > 1) {
      dispatch(setCurrentPage(currentPage - 1));
    }
  }, [currentPage, dispatch]);

  return (
    <div className="p-5 bg-white rounded-md shadow">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">Unitwise Hotel Report</h2>
      </div>

      <div className="mb-4 font-unibold text-lg">
        Datewise no of booking for hotel (
        <span className="text-blue-600">{hotelName}</span>)
      </div>

      <DataTableHeader columns={unitwiseviewColumns} data={dataT} />
      <DataTable
        columns={unitwiseviewColumns}
        data={currentItems}
        enablePagination={false}
      />
      <DataTableFooter
        dataT={dataT}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        handleNextPage={handleNextPage}
        handlePreviousPage={handlePreviousPage}
      />
    </div>
  );
};

export default React.memo(UnitwiseHotelReport);
